var _rect, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopTramWaltti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 22,
    width: 3,
    height: 8,
    rx: 1.5,
    fill: "#333333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3998 21H9.60017C8.71627 21 8 20.2837 8 19.4003V6.60023C8 5.71629 8.71627 5 9.60017 5H22.3998C23.2837 5 24 5.71629 24 6.60023V19.4003C23.9994 20.2837 23.2832 21 22.3998 21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7718 17.2498V10.3973C19.7718 9.81423 19.2988 8.27666 18.7157 8.27666H16.8887L17.4209 7.16864H18.3161V6.6008H13.6844V7.16864H14.5892L15.1214 8.27666H13.2842C12.7011 8.27666 12.2281 9.81423 12.2281 10.3973V17.2498C12.2281 17.8329 12.7006 18.3053 13.2836 18.3059L12.4946 19.4009H13.6494L14.4385 18.3059H17.5615L18.3506 19.4009H19.5054L18.7163 18.3059C19.2994 18.3053 19.7718 17.8329 19.7718 17.2498ZM15.2123 7.16864H16.7984L16.2661 8.27666H15.7446L15.2123 7.16864ZM14.3233 8.95062H17.6766V9.51846H14.3233V8.95062ZM12.9822 16.4833C12.9822 16.1643 13.2407 15.9058 13.5596 15.9058C13.8786 15.9058 14.1371 16.1643 14.1371 16.4833C14.1371 16.8022 13.8786 17.0607 13.5596 17.0607C13.2407 17.0607 12.9822 16.8022 12.9822 16.4833ZM18.4397 17.0607C18.1208 17.0607 17.8623 16.8022 17.8623 16.4833C17.8623 16.1643 18.1208 15.9058 18.4397 15.9058C18.7586 15.9058 19.0172 16.1643 19.0172 16.4833C19.0172 16.8022 18.7586 17.0607 18.4397 17.0607ZM19.0172 14.7916C19.0172 14.9282 18.9443 15.0473 18.8388 15.0828C18.4183 15.224 17.3024 15.3385 15.9997 15.3385C14.697 15.3385 13.5811 15.224 13.1606 15.0828C13.055 15.0473 12.9822 14.9282 12.9822 14.7916V10.3838C12.9822 10.2173 13.09 10.0818 13.2238 10.0818H18.7761C18.9093 10.0818 19.0177 10.2167 19.0177 10.3838V14.7916H19.0172Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopTramWaltti);
export default __webpack_public_path__ + "static/media/stop-tram-waltti.b46ae90d8ab2001fddc0de2d6b94eeff.svg";
export { ForwardRef as ReactComponent };